@if (filterArray && filterArray.filters.length > 0) {
    <p-overlayPanel #op (onShow)="onOverlayPanelShow()" (onHide)="onOverlayPanelHide()" styleClass="w-25rem">
        <div class="p-3 surface-border border-bottom-1 flex justify-content-between align-items-center">
            <span class="text-lg font-bold">{{ 'default-cm-filter' | translate: 'Filter' }}</span>
            <span class="cursor-pointer" (click)="hideOverlayPanel()"><i class="pi pi-times"></i></span>
        </div>
        <form [formGroup]="myForm" (ngSubmit)="applyFilter(op)">
            <div class="p-3 text-sm flex flex-column gap-2 h-21rem overflow-auto">
                @for (items of filterArray.filters; track items) {
                    @for (filter of items.fields; track filter) {
                        <p-panel [toggleable]="true" styleClass="shadow-none surface-border border-1 surface-50">
                            <ng-template pTemplate="header">
                                <div class="align-items-center gap-2 flex justify-content-between w-full">
                                    <span
                                        [pTooltip]="filter.label | translateConfig"
                                        tooltipPosition="bottom"
                                        class="font-bold block overflow-hidden capitalize max-w-15rem text-overflow-ellipsis white-space-nowrap"
                                        >{{ filter.label | translateConfig }}</span
                                    >
                                    @if (['enum', 'search'].includes(filter.filterOptions.type)) {
                                        <div [formGroup]="myForm">
                                            <div [formGroupName]="filter.name" class="gap-2 flex">
                                                <p-checkbox
                                                    binary="true"
                                                    formControlName="_exactMatch"
                                                    inputId="exactMatch_{{ filter.name }}"
                                                ></p-checkbox>
                                                <label
                                                    [for]="'exactMatch_' + filter.name"
                                                    pTooltip="{{
                                                        'default-cm-exactMatchTooltip'
                                                            | translate
                                                                : 'Enable for exact matching, disable for flexible/partial matching'
                                                    }}"
                                                    tooltipPosition="right"
                                                    class="cursor-pointer text-sm max-w-5rem text-overflow-ellipsis white-space-nowrap"
                                                >
                                                    {{ 'default-cm-exactMatch' | translate: 'Exact Match' }}
                                                </label>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </ng-template>
                            <ng-template let-isCollapsed pTemplate="headericons">
                                <div>
                                    <i
                                        class="pi"
                                        [ngClass]="{ 'pi-chevron-down': !isCollapsed, 'pi-chevron-up': isCollapsed }"
                                    ></i>
                                </div>
                            </ng-template>
                            <div class="m-0 p-3 surface-border border-top-1">
                                @switch (filter.filterOptions.type) {
                                    @case ('date-range') {
                                        <app-filter-date-range
                                            [formGroup]="myForm"
                                            [controlName]="filter.name"
                                            [dateFormat]="filter?.filterOptions?.dateFormat"
                                            [label]="filter?.filterOptions.label | translateConfig"
                                            [hide]="hideDateRange"
                                        ></app-filter-date-range>
                                    }
                                    @case ('number-range') {
                                        <app-filter-number-range
                                            [formGroup]="myForm"
                                            [controlName]="filter.name"
                                        ></app-filter-number-range>
                                    }
                                    @case ('search') {
                                        <app-filter-search-range
                                            [formGroup]="myForm"
                                            [controlName]="filter.name"
                                        ></app-filter-search-range>
                                    }
                                    @case ('enum') {
                                        <app-filter-enum
                                            [enumInput]="filter.filterOptions.options"
                                            [formGroup]="myForm"
                                            [controlName]="filter.name"
                                        ></app-filter-enum>
                                    }
                                    @case ('boolean') {
                                        <app-filter-enum
                                            [enumInput]="filter.filterOptions.options"
                                            [formGroup]="myForm"
                                            [controlName]="filter.name"
                                        ></app-filter-enum>
                                    }
                                }
                            </div>
                        </p-panel>
                    }
                }
            </div>
            <div
                class="flex text-md justify-content-end p-3 surface-border border-1 border-x-none border-bottom-none gap-20"
            >
                <p-button
                    label="{{ 'default-cm-clear' | translate: 'Clear' }}"
                    [outlined]="true"
                    styleClass="border-none "
                    (click)="onCancel(op)"
                ></p-button>
                <p-button [disabled]="myForm.invalid" styleClass="shadow-none" type="submit">{{
                    'default-cm-applyFilter' | translate: 'Apply Filter'
                }}</p-button>
            </div>
        </form>
    </p-overlayPanel>
    <p-button [outlined]="true" (click)="op.toggle($event)">
        <span class="flex align-items-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                    d="M14.666 3.33594L8.66602 3.33594"
                    stroke="#265EBE"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M4.66634 3.33594H1.33301"
                    stroke="#265EBE"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M6.66602 5.33594C7.77059 5.33594 8.66602 4.44051 8.66602 3.33594C8.66602 2.23137 7.77059 1.33594 6.66602 1.33594C5.56145 1.33594 4.66602 2.23137 4.66602 3.33594C4.66602 4.44051 5.56145 5.33594 6.66602 5.33594Z"
                    stroke="#265EBE"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M14.6663 10.668L11.333 10.668"
                    stroke="#265EBE"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M6.66634 10.668H1.33301"
                    stroke="#265EBE"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M9 12.668C10.1046 12.668 11 11.7725 11 10.668C11 9.5634 10.1046 8.66797 9 8.66797C7.89543 8.66797 7 9.5634 7 10.668C7 11.7725 7.89543 12.668 9 12.668Z"
                    stroke="#265EBE"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </span>
        <span class="px-2">{{ 'default-cm-filter' | translate: 'Filter' }}</span>
    </p-button>
}
